/* ============================================================
   HESTIA ROASTERS — theme.js
   Mobile nav toggle, header scroll state, quantity steppers,
   newsletter validation. No external dependencies.
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initHeaderScroll();
    initQuantitySteppers();
    initNewsletterValidation();
  });

  /* ---------- Mobile navigation toggle ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.hidden = expanded;
    });

    // Close the menu when a link is tapped
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        toggle.setAttribute('aria-expanded', 'false');
        nav.hidden = true;
      });
    });
  }

  /* ---------- Header scroll state ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Quantity steppers (product page) ---------- */
  function initQuantitySteppers() {
    document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-quantity-input]');
      var minus = wrap.querySelector('[data-quantity-minus]');
      var plus = wrap.querySelector('[data-quantity-plus]');
      if (!input) return;

      var step = function (delta) {
        var current = parseInt(input.value, 10) || 1;
        var next = Math.max(1, current + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      if (minus) minus.addEventListener('click', function () { step(-1); });
      if (plus) plus.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Basic newsletter email validation ---------- */
  function initNewsletterValidation() {
    var forms = document.querySelectorAll('[data-newsletter] form');
    forms.forEach(function (form) {
      var email = form.querySelector('input[type="email"]');
      var error = form.querySelector('[data-newsletter-error]');
      var success = form.querySelector('[data-newsletter-success]');
      if (!email) return;

      form.addEventListener('submit', function (event) {
        var value = email.value.trim();
        var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

        if (!valid) {
          event.preventDefault();
          if (error) error.hidden = false;
          if (success) success.hidden = true;
          email.setAttribute('aria-invalid', 'true');
          email.focus();
        } else {
          email.removeAttribute('aria-invalid');
          if (error) error.hidden = true;
        }
      });

      email.addEventListener('input', function () {
        if (error) error.hidden = true;
        email.removeAttribute('aria-invalid');
      });
    });
  }
})();
